import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { IVisibleProp, LoanFieldProps } from 'config'
import { store } from 'reducers'
import { InputValidate } from 'utils'
import { getInvisibleFields } from 'utils/loan'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'
import { defaultInputs } from './constants'

export const customInformationValidate = (
  borrowerSeperator: BorrowerSeperator,
  fieldOrigin: string,
  validateOnly = false,
  updateStore = false,
) => {
  const fields = defaultInputs(fieldOrigin)
  const { borrower, step, globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps

  if (((loanFieldProperties as any)['visibility'] || {})[fieldOrigin] === false) {
    if (validateOnly) return true
    else return {}
  }

  const fieldProps = (loanFieldProperties[fieldOrigin] || {}) as Record<string, IVisibleProp>

  const data = borrower[borrowerSeperator]
  if (!data) {
    if (validateOnly) {
      return false
    }
    return fields
  }

  const invisibleFields = getInvisibleFields(fieldOrigin as any)
  invisibleFields.forEach((key) => {
    if (fields[key]) fields[key].visible = false
  })

  let success = true

  Object.keys(fields).map((key) => {
    if (fields[key].visible === false) {
      delete fields[key]
      return
    }

    const value = borrower[borrowerSeperator]?.['customInformation']?.[fieldOrigin]?.[key] ?? ''

    if (fieldProps[key]?.required !== undefined) {
      fields[key].required = fieldProps[key].required
    }

    if (borrowerSeperator != BorrowerSeperator.BORROWER && fieldProps[key]?.coborrowerRequired !== undefined) {
      fields[key].required = fieldProps[key].coborrowerRequired
    }

    const error = InputValidate({ ...fields[key], value })
    fields[key].error = error
    if (error.length) success = false

    if (fieldProps[key]?.tooltip) {
      fields[key].tooltip = fieldProps[key].tooltip
    }
  })

  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, fieldOrigin)
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  if (validateOnly) return success

  return fields
}
